// src/AudioSpectrum/effects/burst.js
import { getHSLColor } from '../colorUtils.js';

export const drawBurst = (ctx, frequencyData, width, height, burstRef) => {
  ctx.fillStyle = 'rgba(0, 0, 0, 0.08)';
  ctx.fillRect(0, 0, width, height);
  
  const time = Date.now();
  const bassValue = frequencyData.slice(0, 10).reduce((a, b) => a + b, 0) / 10;
  
  // 베이스 드롭에서 폭발 생성
  if (bassValue > 100 && Math.random() < 0.1) {
    burstRef.current.push({
      x: width / 2 + (Math.random() - 0.5) * width * 0.6,
      y: height / 2 + (Math.random() - 0.5) * height * 0.6,
      radius: 0,
      maxRadius: bassValue * 2,
      life: 1.0,
      decay: 0.015,
      color: getHSLColor(Math.random() * 360, 100, 60),
      shockwaves: [],
      birthTime: time
    });
  }
  
  // 폭발 업데이트
  burstRef.current = burstRef.current.filter(burst => {
    const age = (time - burst.birthTime) / 1000;
    burst.radius = Math.min(burst.radius + burst.maxRadius * 0.05, burst.maxRadius);
    burst.life -= burst.decay;
    
    if (burst.life > 0) {
      // 메인 폭발원
      const gradient = ctx.createRadialGradient(
        burst.x, burst.y, 0,
        burst.x, burst.y, burst.radius
      );
      gradient.addColorStop(0, burst.color.replace('60', '80'));
      gradient.addColorStop(0.7, burst.color.replace('60', '40'));
      gradient.addColorStop(1, 'transparent');
      
      ctx.globalAlpha = burst.life;
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(burst.x, burst.y, burst.radius, 0, Math.PI * 2);
      ctx.fill();
      
      // 충격파 링
      if (age > 0.1 && burst.shockwaves.length < 3) {
        burst.shockwaves.push({
          radius: burst.radius * 0.8,
          life: 1.0,
          decay: 0.03
        });
      }
      
      // 충격파 렌더링
      burst.shockwaves = burst.shockwaves.filter(wave => {
        wave.radius += 5;
        wave.life -= wave.decay;
        
        if (wave.life > 0) {
          ctx.globalAlpha = wave.life * 0.5;
          ctx.strokeStyle = burst.color;
          ctx.lineWidth = 3;
          ctx.beginPath();
          ctx.arc(burst.x, burst.y, wave.radius, 0, Math.PI * 2);
          ctx.stroke();
          return true;
        }
        return false;
      });
      
      ctx.globalAlpha = 1.0;
      return true;
    }
    return false;
  });
};